var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNameIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.594,
    height: 19.122,
    viewBox: "0 0 16.594 19.122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11879",
    "data-name": "Group 11879",
    transform: "translate(-132.133 -536.634)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_9025772_newspaper_clipping_icon",
    "data-name": "9025772_newspaper_clipping_icon",
    transform: "translate(135.956 539.809)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5833",
    "data-name": "Rectangle 5833",
    width: 12.772,
    height: 12.772,
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20273",
    "data-name": "Path 20273",
    d: "M32,56.243v-7.85A.393.393,0,0,1,32.393,48h8.635a.393.393,0,0,1,.393.393v7.85l-1.57-.785-1.57.785-1.57-.785-1.57.785-1.57-.785Z",
    transform: "translate(-30.66 -45.875)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_514",
    "data-name": "Line 514",
    x2: 2.017,
    transform: "translate(6.722 5.378)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_515",
    "data-name": "Line 515",
    x2: 2.017,
    transform: "translate(6.722 6.722)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5834",
    "data-name": "Rectangle 5834",
    width: 2.017,
    height: 4.033,
    transform: "translate(3.361 4.033)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "_6579057_alarm_and_computers_hardware_iphone_icon",
    "data-name": "6579057_alarm_and_computers_hardware_iphone_icon",
    transform: "translate(132.283 536.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20274",
    "data-name": "Path 20274",
    d: "M14.083,17.461a.635.635,0,0,0-.672.672v.672a.635.635,0,0,1-.672.672H6.017a.635.635,0,0,1-.672-.672V4.017a.635.635,0,0,1,.672-.672h.672v.2A1.807,1.807,0,0,0,8.5,5.361h1.748a1.807,1.807,0,0,0,1.815-1.815v-.2h.672a.635.635,0,0,1,.672.672V5.361a.672.672,0,0,0,1.344,0V4.017A1.981,1.981,0,0,0,12.739,2H6.017A1.981,1.981,0,0,0,4,4.017V18.805a1.981,1.981,0,0,0,2.017,2.017h6.722a1.981,1.981,0,0,0,2.017-2.017v-.672A.635.635,0,0,0,14.083,17.461Z",
    transform: "translate(-4 -2)",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20277",
    "data-name": "Path 20277",
    d: "M8.672,24a.672.672,0,0,0,0,1.344h4.033a.672.672,0,1,0,0-1.344Z",
    transform: "translate(-5.311 -9.212)",
    stroke: "#fff",
    strokeWidth: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNameIcon);
export default __webpack_public_path__ + "static/media/name-icon.9614a02ce564c4ea226cee768cc9b063.svg";
export { ForwardRef as ReactComponent };